import { LANGUAGES_LINKEDIN_OPTIONS } from "./catalogs/languageOptions";
import { normalizeLanguageCode } from "./catalogs/contentLanguage";

export const LANGUAGE_CODE_BY_URN = {
  "urn:li:locale:ar_AE": "ar",
  "urn:li:locale:cs_CZ": "cs",
  "urn:li:locale:da_DK": "da",
  "urn:li:locale:nl_NL": "nl",
  "urn:li:locale:en_US": "en",
  "urn:li:locale:fr_FR": "fr",
  "urn:li:locale:de_DE": "de",
  "urn:li:locale:hi_IN": "hi",
  "urn:li:locale:in_ID": "id",
  "urn:li:locale:it_IT": "it",
  "urn:li:locale:ja_JP": "ja",
  "urn:li:locale:ko_KR": "ko",
  "urn:li:locale:ms_MY": "ms",
  "urn:li:locale:no_NO": "no",
  "urn:li:locale:pl_PL": "pl",
  "urn:li:locale:pt_BR": "pt",
  "urn:li:locale:ro_RO": "ro",
  "urn:li:locale:ru_RU": "ru",
  "urn:li:locale:es_ES": "es",
  "urn:li:locale:sv_SE": "sv",
  "urn:li:locale:tr_TR": "tr",
  "urn:li:locale:el_GR": "el",
};

export const resolveLinkedInLanguageCode = (language) => {
  if (!language) return "en";
  const rawValue =
    typeof language === "object" && language?.value != null
      ? language.value
      : language;
  const raw = String(rawValue).trim();
  if (LANGUAGE_CODE_BY_URN[raw]) {
    return LANGUAGE_CODE_BY_URN[raw];
  }

  const localeMatch = raw.match(/locale:([a-z]{2})_/i);
  if (localeMatch) {
    return localeMatch[1].toLowerCase();
  }

  return normalizeLanguageCode(raw) || "en";
};

const toCampaignLanguageList = (campaignLanguage) => {
  if (Array.isArray(campaignLanguage)) {
    return campaignLanguage;
  }
  if (campaignLanguage == null || campaignLanguage === "") {
    return [];
  }
  return [campaignLanguage];
};

export const canSelectLeadFormForCampaign = (
  formLanguage,
  campaignLanguage
) => {
  const formCode = resolveLinkedInLanguageCode(formLanguage);
  if (formCode === "en") return true;

  const campaignCodes = toCampaignLanguageList(campaignLanguage).map((item) =>
    resolveLinkedInLanguageCode(item)
  );
  return campaignCodes.includes(formCode);
};

export const getLeadFormLanguageOption = (language) => {
  const code = resolveLinkedInLanguageCode(language);
  const urn = Object.keys(LANGUAGE_CODE_BY_URN).find(
    (key) => LANGUAGE_CODE_BY_URN[key] === code
  );
  return LANGUAGES_LINKEDIN_OPTIONS.find((option) => option.value === urn);
};

const normalizeLeadFormID = (value) => {
  if (value == null) return "";
  const raw = String(value).trim();
  if (!raw) return "";

  const lastSegment = raw.split(":").pop()?.trim() || "";
  if (/^\d+$/.test(lastSegment)) {
    return lastSegment;
  }

  return raw;
};

// Match plain ids and LinkedIn URNs (urn:li:leadGenForm:123 vs 123).
export const isSameLeadFormID = ({ a, b }) => {
  const normalizedA = normalizeLeadFormID(a);
  const normalizedB = normalizeLeadFormID(b);
  if (!normalizedA || !normalizedB) return false;
  return normalizedA === normalizedB;
};

export const getLeadFormViewValues = ({ leadForm, campaignLanguage }) =>
  leadForm?.duplicateValues || {
    name: leadForm?.name || "",
    language: leadForm?.language || campaignLanguage,
  };
